import {
  LayoutDashboard,
  Clock,
  Calendar,
  CalendarDays,
  Film,
  Tag,
  MapPin,
  Users,
  Flag,
  Clapperboard,
  Globe,
  CalendarCheck,
  History,
  Activity,
  UserCog,
  type LucideIcon,
} from "lucide-react";

export interface PageNavEntry {
  to: string;
  icon: LucideIcon;
  /** Title shown in the top bar. */
  title: string;
  /** Roles allowed to see this destination in the command palette. */
  roles: Array<"admin" | "organizer">;
}

/**
 * Single source of truth for routable destinations — drives both the top-bar
 * page title and the ⌘K command palette "Przejdź do" list. The sidebar keeps
 * its own grouped list (with section labels and badges), but titles are read
 * from here so they stay consistent.
 */
export const PAGE_NAV: PageNavEntry[] = [
  { to: "/dashboard", icon: LayoutDashboard, title: "Pulpit", roles: ["admin"] },
  { to: "/pending", icon: Clock, title: "Oczekujące", roles: ["admin"] },
  { to: "/events", icon: Calendar, title: "Wszystkie wydarzenia", roles: ["admin"] },
  { to: "/parent-events", icon: CalendarDays, title: "Cykle wydarzeń", roles: ["admin"] },
  { to: "/movies", icon: Film, title: "Filmy", roles: ["admin"] },
  { to: "/categories", icon: Tag, title: "Kategorie", roles: ["admin"] },
  { to: "/venues", icon: MapPin, title: "Lokalizacje", roles: ["admin"] },
  { to: "/users", icon: Users, title: "Użytkownicy", roles: ["admin"] },
  { to: "/reports", icon: Flag, title: "Zgłoszenia", roles: ["admin"] },
  { to: "/scrapers/ock", icon: Clapperboard, title: "OCK — Skrobak", roles: ["admin"] },
  { to: "/ai-agent/sources", icon: Globe, title: "Agent AI — Źródła", roles: ["admin"] },
  { to: "/ai-agent/events", icon: CalendarCheck, title: "Agent AI — Wydarzenia", roles: ["admin"] },
  { to: "/ai-agent/runs", icon: History, title: "Agent AI — Historia", roles: ["admin"] },
  { to: "/system-logs", icon: Activity, title: "Logi systemu", roles: ["admin"] },
  { to: "/my-events", icon: Calendar, title: "Moje wydarzenia", roles: ["organizer"] },
  { to: "/my-profile", icon: UserCog, title: "Moje dane", roles: ["organizer"] },
];

/** Resolve the page title for the current pathname (longest-prefix match). */
export function titleForPath(pathname: string): string {
  const match = PAGE_NAV.filter((p) => pathname === p.to || pathname.startsWith(p.to + "/")).sort(
    (a, b) => b.to.length - a.to.length,
  )[0];
  return match?.title ?? "PulsO";
}
